import { useMutation, useQueryClient, useSuspenseInfiniteQuery } from "@tanstack/react-query";
import { useCallback, useMemo, useRef, useState } from "react";
import { useIntersectionObserver } from "../../../utilities/customHooks/useIntersectionObserver";
import { nextPageParam } from "../../DataInput/Helper";
import { deleteFile, fMDocumentsLists } from "../config";
import { Primary } from "../../../core-components/theme/color-palette/colors";
import { formatDistanceToNow } from "date-fns";
import { toast } from "react-toastify";
import { DeleteFilePayload, SelectedFileForPreviewInterface } from "../types";

const useFMListingView = (queryKeyData: string[]) => {
  const uploaderChipStyles = {
    backgroundColor: Primary[50],
    border: Primary[200],
    color: Primary[900],
    fontSize: '13px',
  }
  const tableContainerRef = useRef<HTMLDivElement>(null);
  const lastElementRef = useRef<HTMLTableRowElement>(null);
  const [selectedFile, setSelectedFile] = useState<SelectedFileForPreviewInterface | null>(null);
  const queryClient: any = useQueryClient();
  const handleDeleteFile = useMutation({
      mutationFn: (payload: DeleteFilePayload) => deleteFile(payload ),
      onSuccess: (data: any) => {
        queryClient.invalidateQueries({ queryKey: queryKeyData });

        toast.success(data?.message || `File deleted Successfully`);
      },
      onError: (error: any) => {
        toast.error(error?.message || `Problem in deleting File`);
      },
    });

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useSuspenseInfiniteQuery({
    queryKey: queryKeyData,
    // @ts-ignore
    queryFn: fMDocumentsLists,
    initialPageParam: 1,
    getNextPageParam: nextPageParam,
    refetchOnWindowFocus: false,
    retry: 0
  });

  useIntersectionObserver(
    tableContainerRef,
    lastElementRef,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  );

  const fMLists = useMemo(() => {
    console.log("FM Lists Data: ", data);
    return data?.pages.flatMap(page => page?.data?.filesWithUrls || []) ?? [];
  }, [data]);

  const getRelativeTime = (timestamp: string) => {
    return formatDistanceToNow(new Date(timestamp), { addSuffix: true });
  }

  const handleDelete = useCallback((fileObj: {_id: string, s3Key: string}) => {
    let payload = {
      id: fileObj?._id,
      path: `${fileObj?.s3Key}`
    }
    handleDeleteFile.mutate(payload);
  }, [])

  const handleView = useCallback((fileObj: SelectedFileForPreviewInterface) => {
    setSelectedFile(fileObj)
  }, [selectedFile])

  const handleCloseFileViewer = useCallback(() => {
    setSelectedFile(null)
  }, [])


  return {
    fetchNextPage,
    hasNextPage,
    isLoading: isFetchingNextPage,
    lastElementRef,
    tableContainerRef,
    listData: fMLists,
    uploaderChipStyles,
    getRelativeTime,
    handleDelete,
    handleView,
    handleCloseFileViewer,
    selectedFile
  };
}

export default useFMListingView;